import { render, staticRenderFns } from "./GospelPresentationsModal.vue?vue&type=template&id=262e597a&scoped=true&"
import script from "./GospelPresentationsModal.vue?vue&type=script&lang=js&"
export * from "./GospelPresentationsModal.vue?vue&type=script&lang=js&"
import style0 from "./GospelPresentationsModal.vue?vue&type=style&index=0&id=262e597a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262e597a",
  null
  
)

export default component.exports